module.exports = __webpack_public_path__ + "static/media/check.ce20ce8e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/check.svg
// module id = 1943
// module chunks = 0